import request from "../utils/request";

//获取列表
export function getAutoLayoutList(params) {
  const queryString = Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');
  return request({
    url: `/autoLayout/listAll?${queryString}`,
    method: "get",
  });
}

// 更新config
export function updateConfig(params) {
  return request({
    url: `/autoLayout/updateConfig`,
    method: "post",
    data:params
  });
}

// 新增config
export function addConfig(params) {
  return request({
    url: `/autoLayout/addConfig`,
    method: "post",
    data:params
  });
}

// 根据id查询
export function getConfigById(id) {
  return request({
    url: `/autoLayout/getConfigById?id=${id}`,
    method: "get",
  });
}

// 删除配置
export function deleteConfig(id) {
  return request({
    url: `/autoLayout/deleteConfig?id=${id}`,
    method: "get",
  });
}